import {
  GET_CARGO_MAIN_LIST,
  GET_CARGO_MAIN_LIST_SUCCESS,
  GET_CARGO_MAIN_LIST_FAIL,
  GET_SINGLE_CARGO_MAIN,
  GET_SINGLE_CARGO_MAIN_SUCCESS,
  GET_SINGLE_CARGO_MAIN_FAIL,
  DELETE_CARGO_MAIN_REQUEST,
  DELETE_CARGO_MAIN_SUCCESS,
  DELETE_CARGO_MAIN_FAIL,
  ADD_CARGO_MAIN_REQUEST,
  ADD_CARGO_MAIN_SUCCESS,
  ADD_CARGO_MAIN_FAIL,
  UPDATE_CARGO_MAIN_REQUEST,
  UPDATE_CARGO_MAIN_SUCCESS,
  UPDATE_CARGO_MAIN_FAIL,
} from "src/constants/types";

export const cargoMainReducers = (state = {}, actions) => {
  switch (actions.type) {
    case GET_CARGO_MAIN_LIST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_CARGO_MAIN_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        cargoMainList: actions.payload,
        error: "",
      };
    case GET_CARGO_MAIN_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case GET_SINGLE_CARGO_MAIN:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_SINGLE_CARGO_MAIN_SUCCESS:
      return {
        ...state,
        loading: false,
        cargoMain: actions.payload,
      };
    case GET_SINGLE_CARGO_MAIN_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case DELETE_CARGO_MAIN_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case DELETE_CARGO_MAIN_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case DELETE_CARGO_MAIN_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case ADD_CARGO_MAIN_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case ADD_CARGO_MAIN_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case ADD_CARGO_MAIN_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case UPDATE_CARGO_MAIN_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case UPDATE_CARGO_MAIN_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case UPDATE_CARGO_MAIN_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    default:
      return state;
  }
};
